import { FormEvent, ReactNode, useEffect, useState } from "react";
import { api, clearAdminToken, getAdminToken, setAdminToken } from "../../api";

export function AdminAuthGate({ children }: { children: ReactNode }) {
  const [status, setStatus] = useState<"checking" | "authenticated" | "login">("checking");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!getAdminToken()) {
      setStatus("login");
      return;
    }

    api
      .getAdminSession()
      .then(() => setStatus("authenticated"))
      .catch(() => {
        clearAdminToken();
        setStatus("login");
      });
  }, []);

  async function login(event: FormEvent) {
    event.preventDefault();
    setError("");
    try {
      const result = await api.loginAdmin(password);
      setAdminToken(result.token);
      setStatus("authenticated");
      setPassword("");
    } catch (loginError) {
      setError(loginError instanceof Error ? loginError.message : "Нэвтрэхэд алдаа гарлаа.");
    }
  }

  if (status === "checking") {
    return <main className="admin-login-page">Шалгаж байна...</main>;
  }

  if (status === "login") {
    return (
      <main className="admin-login-page">
        <form className="admin-login-card" onSubmit={login}>
          <strong>PicShot Admin</strong>
          <h1>Нэвтрэх</h1>
          <label>
            Нууц үг
            <input autoFocus required type="password" value={password} onChange={(event) => setPassword(event.target.value)} />
          </label>
          {error && <p className="admin-login-error">{error}</p>}
          <button type="submit">Нэвтрэх</button>
          <a href="/">User тал руу буцах</a>
        </form>
      </main>
    );
  }

  return <>{children}</>;
}
